<template>
  <div class="choose-sch">
    <Modal v-model="show" title="选择机构账户" :width="modalWidth">
      <MultipleTable
        ref="multipleTableRef"
        :right-title="`选中的机构账户`"
        :table-data="accountList"
        :table-columns="inAccountType == 3 ? orgListColumn : schoolListColumn"
        :select-data="selectAccountList"
        :table-loading="loading"
      >
        <template #left-header>
          <div class="remark" style="margin-bottom: 16px">
            <slot name="remark"></slot>
          </div>
          <div class="search-wrap">
            <Form ref="formInline" inline>
              <FormItem>
                <Input
                  v-model="searchForm.acctName"
                  type="text"
                  clearable
                  placeholder="请输入机构账户名称"
                >
                </Input>
              </FormItem>

              <!-- <FormItem>
                <ChooseArea @on-change="onAreaChange"></ChooseArea>
              </FormItem> -->
              <Button type="primary" @click="handleSearch">搜索</Button>
            </Form>
          </div>
        </template>
        <template #left-footer>
          <div class="page-wrap">
            <Page
              :current="pageInfo.pageNum"
              :total="pageInfo.total"
              :page-size="pageInfo.pageSize"
              show-total
              show-elevator
              @on-change="pageChange"
            ></Page>
          </div>
        </template>
      </MultipleTable>
      <div class="other" style="padding-top: 16px">
        <slot name="other"></slot>
      </div>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import orderCenterApi from '@/request/orderCenter/index.js';
import MultipleTable from '@c/Base/MultipleTable';
import ChooseArea from '@c/searchBlock/ChooseArea.vue';
export default {
  components: {
    MultipleTable,
    ChooseArea
  },
  props: {

    modalWidth: {
      type: [Number, String],
      default: 75
    },
    bankId: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      show: false,

      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchForm: {
        acctName: '',
        areaCode: ''
      },
      portOrg: localStorage.getItem('portOrg'),

      schoolListColumn: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '机构账户名称',
        key: 'acctName',
        minWidth: 200
      }, {
        title: '商户简称',
        key: 'shortName',
        minWidth: 180
      },
      {
        title: '商户类别',
        key: 'merchantKindName',
        width: 120
      },
      {
        title: '所属地区',
        key: 'areaName',
        width: 280
      },
      {
        title: '监管银行',
        key: 'bankName',
        width: 150
      }],
      orgListColumn: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '机构名称',
        key: 'name',
        minWidth: 200
      },
      {
        title: '单位类型',
        key: 'merchantKindName',
        width: 120
      },
      {
        title: '所属地区',
        key: 'areaName',
        width: 280
      }],
      accountList: [], // 表格单位列表
      selectAccountList: [], // 选中的学校列表
      loading: false,
      inAccountType: 1
    };
  },
  created() {

  },
  methods: {
    // 行政区域改变
    onAreaChange(area) {
      this.searchForm.areaCode = area.length ? area[area.length - 1] : '';
    },
    handleOpen(data = [], inAccountType = 1) {
      this.inAccountType = inAccountType;
      this.show = true;
      this.pageInfo.pageNum = 1;
      this.selectAccountList = data;
      this.getDivideConfigdFindAccountList();
    },

    getSelectSchoolRow() {

    },
    handleSchoolPageChange() {

    },
    getOrgName(orgType) {
      // 单位类型
      const orgTyleList = ['--', '学校', '教育集团', '教育局', '教培机构', '技术服务商', '宏途', '代理商'];
      return orgTyleList[orgType];
    },
    getMerchantKindName(type) {
      if ([11, 12, 13].includes(Number(type))) {
        return '个人类';
      } else {
        return '企业类';
      }
    },
    handleCancel() {
      this.show = false;
    },
    handleOk(data) {
      this.$emit('on-finish', this.$refs.multipleTableRef.getResult());
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
      this.getDivideConfigdFindAccountList();
    },
    // 获取机构账户列表
    async getDivideConfigdFindAccountList() {
      if (this.inAccountType == 3) {
        this.getOrgList();
      } else {
        this.getAccountList();
      }
    },
    async getAccountList() {
      const params = {
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        acctName: this.searchForm.acctName,
        bankId: this.bankId,
        merchantKind: 4
      };
      let res = {};
      this.loading = true;
      res = await orderCenterApi.getDivideConfigdFindAccountList(params);
      this.loading = false;
      if (res.status === 200) {
        this.accountList = res.message.list.map(item => {
          item.id = item.acctNo;
          item.name = item.acctName;
          item.merchantKindName = this.getMerchantKindName(item.merchantKind);
          item._checked = false;

          if (this.selectAccountList.findIndex((item_1) => { return item_1.acctNo == item.acctNo; }) != -1) {
            item._checked = true;
          }
          return item;
        });
        this.pageInfo.total = Number(res.message.total);
      }
    },
    async getOrgList() {
      const params = {
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        searchStr: this.searchForm.acctName,
        orgTypes: [4]
      };
      let res = {};
      this.loading = true;
      res = await orderCenterApi.getorgPageList(params);
      this.loading = false;
      if (res.status === 200) {
        this.accountList = res.message.list.map(item => {
          item.id = item.orgId;
          item.merchantKindName = this.getOrgName(item.orgType);
          item._checked = false;

          if (this.selectAccountList.findIndex((item_1) => { return item_1.acctNo == item.acctNo; }) != -1) {
            item._checked = true;
          }
          return item;
        });
        this.pageInfo.total = Number(res.message.total);
      }
    },

    // 点击搜索
    handleSearch() {
      this.getDivideConfigdFindAccountList();
    }

  }
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;

  .left {
    width: calc(100% - 400px);
    margin-right: 16px;
  }

  .right {
    width: 400px;

    .select-list-wrap {
      max-height: 500px;
      overflow-y: scroll;
      padding: 10px 10px 0;
      border-radius: 4px;
      background-color: #eee;

      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        font-size: 14px;
      }
    }
  }
}
</style>
